@if (selectedLogon?.error) {
<pl-error-load-user-info messageType="BLOCK_USER"> </pl-error-load-user-info>
} @else {
<seds-modal>
  <div header>Bloqueio de usuário</div>
  <div content>
    <div class="dialog-content__fade-in">
      @if (!hasSuccess && (selectBlockUserFeature$ | async)?.error) {
      <pl-alert color="error" display="block">
        <span header>Não foi possível BLOQUEAR o usuário</span>
        <span content
          >Estamos trabalhando para resolver esse problema. Por favor, tente
          novamente mais tarde e, se o erro persistir, entre em contato com a
          nossa equipe de atendimento.</span
        >
      </pl-alert>
      } @if (hasSuccess) {
      <pl-alert class="dialog-content__alert" color="success">
        <span header>Bloqueio realizado com sucesso</span>
      </pl-alert>
      } @if (!hasSuccess && !(selectBlockUserFeature$ | async)?.error) {

      <p class="dialog-content__description">
        O usuário abaixo será BLOQUEADO e não conseguirá acessar o Menu de
        Produtos até ser desbloqueado.
      </p>
      } @if (selectedLogon$ | async; as logon) {
      <section class="dialog-content__box">
        <ul class="dialog-content__box__list">
          <li class="dialog-content__box__list__item">
            Nome:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold': logon?.fullname,
                'dialog-content__box__list__item--italic': !logon?.fullname
              }"
              >{{ logon?.fullname || "Não cadastrado" }}</span
            >
          </li>
          @if (logon?.document?.documentCountry === 'BRA' || !logon?.document) {
          <li>
            CPF:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold':
                  logon?.document?.documentId,
                'dialog-content__box__list__item--italic':
                  !logon?.document?.documentId
              }"
              >{{
                (logon?.document?.documentId | document : true) ||
                  "Não cadastrado"
              }}</span
            >
          </li>
          } @if (logon?.document && logon?.document?.documentCountry !== 'BRA')
          {
          <li>
            RNM:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold':
                  logon?.document?.documentId,
                'dialog-content__box__list__item--italic':
                  !logon?.document?.documentId
              }"
              >{{
                (logon?.document?.documentId | document : true) ||
                  "Não cadastrado"
              }}</span
            >
          </li>
          }
          <li>
            Logon:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold': logon?.logon,
                'dialog-content__box__list__item--italic': !logon?.logon
              }"
              >{{ logon?.logon || "Não cadastrado" }}</span
            >
          </li>
          <li>
            E-mail:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold': logon?.email,
                'dialog-content__box__list__item--italic': !logon?.email
              }"
              >{{ logon?.email || "Não cadastrado" }}</span
            >
          </li>
          <li>
            Celular: @if (logon?.phone) {

            <span class="dialog-content__box__list__item--bold">{{
              logon?.phone?.areaCode + "" + logon?.phone?.phoneNumber
                | phone : false
            }}</span>
            } @if (!logon?.phone) {
            <span class="dialog-content__box__list__item--italic"
              >Não cadastrado</span
            >
            }
          </li>
          @if (hasSuccess) {
          <li>
            Justificativa de bloqueio:
            <span class="dialog-content__box__list__item--bold">{{
              justificationSelected?.value
            }}</span>
          </li>
          }
        </ul>
      </section>
      } @if (!hasSuccess && !(selectBlockUserFeature$ | async)?.error) {
      <seds-form-field-dropdown
        class="dialog-content__dropdown"
        label="Justificativa do bloqueio*"
        [optionList]="justificationList"
        [(model)]="justification"
      ></seds-form-field-dropdown>
      }
    </div>
  </div>
  <div class="footer w-100 d-flex justify-content-end" footer>
    @if (!hasSuccess && !(selectBlockUserFeature$ | async)?.error) {
    <div class="buttons-wrapper">
      <seds-flat-button
        mat-dialog-close
        class="btn-cancelar__fade-in"
        data-test="btn-cancelar"
        launchLabel="Cancelar"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
        title="Cancelar"
      ></seds-flat-button>

      <seds-basic-button
        class="btn-bloquear__fade-in"
        data-test="btn-bloquear"
        [size]="smallButton"
        title="Bloquear"
        launchLabel="Bloquear"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
        [disabled]="
          !justification ||
          !selectedLogon?.userId ||
          selectedLogon?.error ||
          isLoading
        "
        (click)="blockUser()"
      ></seds-basic-button>
    </div>
    } @if (hasSuccess || (selectBlockUserFeature$ | async)?.error) {
    <div class="buttons-wrapper">
      <seds-basic-button
        mat-dialog-close
        class="btn-concluir__fade-in"
        data-test="btn-concluir"
        [size]="smallButton"
        launchLabel="Concluir"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
        title="Concluir"
      ></seds-basic-button>
    </div>
    }
  </div>
</seds-modal>
}
